import React, { memo } from 'react';
import { validators } from 'investira.sdk';
import { Stack, Typography, Card, CardContent } from 'investira.react.components';
import { InlineInfo } from '../../molecules';

/**
 * Renderiza o componente CvmSection.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {*} props.pessoa - Propriedade `pessoa` do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const CvmSection = memo(props => {
  const { pessoa } = props;

  if (validators.isEmpty(pessoa?.cvm)) {
    return null;
  }

  return (
    <Stack
      flexGrow={1}
      sx={{ minWidth: '288px' }}
      component="section"
      aria-label={`Informações da CVM: ${pessoa.pessoa_fantasia || pessoa.pessoa}`}>
      <Card sx={{ height: '100%' }}>
        <CardContent
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
          }}>
          <Stack spacing={2} sx={{ py: 2 }}>
            <Stack>
              <Typography
                variant="subtitle1"
                color="textPrimary"
                sx={{ fontWeight: 600 }}
                title="Informações da CVM"
                component="h3">
                CVM
              </Typography>
            </Stack>
            <Stack direction="column" sx={{ gap: 1 }}>
              <InlineInfo label="Setor de atividade" value={pessoa?.cvm?.setor_atividade} />
              <InlineInfo label="Código" value={pessoa?.cvm?.codigo} />
              <InlineInfo label="Registro" variant="date" value={pessoa?.cvm?.registro} />
              <InlineInfo label={'Responsável'} value={pessoa.cvm?.responsavel?.nome} />
              <InlineInfo
                label="E-mail do reponsável "
                value={pessoa.cvm?.responsavel?.email}
                variant="email"
                divider="false"
              />
              <InlineInfo
                label="Cia Aberta"
                value={pessoa.cvm?.cia_aberta ? 'Sim' : 'Não'}
                divider="false"
              />
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
});

export default CvmSection;
